import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Doughnut } from 'react-chartjs-2';
import staticInformationService from '../../../services/Internal/Staff/dashboardInformation.service';

function DashboardPendingCounts() {
    const [pendingCounts, setPendingCounts] = useState();
    const [hasLoaded, setHasLoaded] = useState(false);
    const pendingCountsConfig = {
        labels: ['Application', 'Reinstatement', 'Renewal'],
        options: {
            parsing: {
                key: 'count.total'
            },
            plugins: {
                legend: {
                    position: 'bottom'
                },
                title: {
                    display: true,
                    text: 'Currently Pending',
                    font: {
                        size: 20,
                        family: 'Arial',
                    },
                    //fullSize: true
                },
                tooltip: {
                    callbacks: {
                        title: function (tooltipItem) {
                            return tooltipItem[0].label;
                        },
                        label: function (tooltipItem) {
                            var dataIndex = tooltipItem.dataIndex;
                            var data = tooltipItem.dataset.data[dataIndex];
                            var tooltipStringArray = [];
                            tooltipStringArray.push(`Total: ${data.count.total}`);
                            tooltipStringArray.push(`Individual: ${data.count.individual}`);
                            tooltipStringArray.push(`Firm: ${data.count.firm}`);
                            return tooltipStringArray;
                        }
                    },
                    backgroundColor: '#000',
                    titleFontSize: 16,
                    titleFontColor: '#0066ff',
                    bodyFontColor: '#000',
                    bodyFontSize: 14,
                    displayColors: true
                },
                annotation: {
                    annotations: {
                        dLabel: {
                            type: 'doughnutLabel',
                            content: ({ chart }) =>
                                ['Total',
                                    chart.getDatasetMeta(0).total
                                ]
                            ,
                            font: [{ size: 40 }, { size: 30 }],
                            color: ['black', 'grey']
                        }
                    }
                },
                datalabels: {
                    formatter: function (value, context) {
                        return value.count.total;
                    },
                    font: {
                        size: 24,
                        weight: 'bold',
                        family: 'Arial',
                        style: 'normal',
                    },
                    color: 'white'
                },
            },
            maintainAspectRatio: false
        }
    }
    useEffect(() => {
        staticInformationService.getDashboardNumbers().then((response) => {
            let pendingCountResponse = response;
            var numbersData = [
                {
                    type: "Application",
                    count:
                    {
                        total: (pendingCountResponse.data.pendingIndividualApplications + pendingCountResponse.data.pendingFirmApplications).toLocaleString("en-US"),
                        individual: pendingCountResponse.data.pendingIndividualApplications.toLocaleString("en-US"),
                        firm: pendingCountResponse.data.pendingFirmApplications.toLocaleString("en-US")
                    },
                },
                {
                    type: "Reinstatement",
                    count:
                    {
                        total: (pendingCountResponse.data.pendingIndividualReinstatements + pendingCountResponse.data.pendingFirmReinstatements).toLocaleString("en-US"),
                        individual: pendingCountResponse.data.pendingIndividualReinstatements.toLocaleString("en-US"),
                        firm: pendingCountResponse.data.pendingFirmReinstatements.toLocaleString("en-US")
                    },
                },
                {
                    type: "Renewal",
                    count:
                    {
                        total: (pendingCountResponse.data.pendingIndividualRenewals + pendingCountResponse.data.pendingFirmRenewals).toLocaleString("en-US"),
                        individual: pendingCountResponse.data.pendingIndividualRenewals.toLocaleString("en-US"),
                        firm: pendingCountResponse.data.pendingFirmRenewals.toLocaleString("en-US")
                    },
                }]
            setPendingCounts(
                {
                    labels: pendingCountsConfig.labels,
                    datasets: [{
                        label: 'Total',
                        data: numbersData,
                        datalabels: {
                            anchor: 'center'
                        },
                        backgroundColor: [
                            '#007ea6',
                            '#005874',
                            'rgba(106,220,255,1)'
                        ],
                        borderWidth: 1
                    }
                    ]
                }
            );
            setHasLoaded(true);
        })
    }, [])
    ChartJS.register(
        ArcElement,
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        annotationPlugin
    );


    return (
        hasLoaded &&
        <Doughnut data={pendingCounts} options={pendingCountsConfig.options} plugins={[ChartDataLabels]} />
    )
}

export default DashboardPendingCounts;